import { BlockComponent } from "../../../framework/src/BlockComponent";
import { runEngine } from "../../../framework/src/RunEngine";
import { Message } from "../../../framework/src/Message";
import { IBlock } from "../../../framework/src/IBlock";
import MessageEnum, {
  getName,
} from "../../../framework/src/Messages/MessageEnum";

// Customizable Area Start
import { IFilter } from "../../../components/src/FilterPopover";
import { ISortingData } from "../../../components/src/SortingTableHeader2";
import { makeApiMessage as MakeApiMessage } from "../../../components/src/common";
import { IUserContext } from "../../../blocks/navigationmenu/src/PageContainerController.web";
import {
  PermissionStatus,
  checkForNewPermissonStatus,
  customPermissionApiKey,
  navigateTo,
} from "../../../blocks/utilities/src/CustomBlockHelpers";
import { PermissionGroupArray } from "../../../blocks/navigationmenu/src/utils";
import moment from "moment";
import { isArray } from "lodash";

export const configJSON = require("./config");

export interface IGoldenPointType {
  id: number;
  name: string;
}

export interface ISection {
  id: number;
  name: string;
  section_name: string;
  section_second_name: string;
}

export interface IGoldenPointItem {
  id: string;
  type: string;
  attributes: {
    name: string;
    total_points: string;
    start_date: string;
    end_date: string;
    start_date_base: string;
    end_date_base: string;
    purchase_start_date: string;
    purchase_end_date: string;
    status: string;
    // golden_point_type: IGoldenPointType;
  };
}

interface IFilterOmitValue extends Omit<IFilter, "value"> {
  value?: string | string[] | Date[] | [null, null] | [undefined, undefined];
}

export interface IFilterItem extends Omit<IFilterOmitValue, "apiKey"> {
  apiKey?: string | string[];
}

const Strings = {
  pageTitle: "Golden Points",
  addGoldenPoint: "Add Golden Points",
  noRecordFounds: "Golden Point Not found",
  view: "View",
  edit: "Edit",
  deactivate: "Deactivate",
  activate: "Activate",
  active: "Active",
};

const ApiUrls = {
  goldenPointList: "bx_block_cfgoldenpoints0/golden_points",
  goldenPointDeactivate: "bx_block_cfgoldenpoints0/golden_points",
  sectionSuggestion:
    "bx_block_cfgoldenpoints0/golden_points/golden_point_filter?section_ids=",
  goldenpointNameSuggestion:
    "bx_block_cfgoldenpoints0/golden_points/golden_point_filter?section_ids=",
  sectionList: "bx_block_categories/categories?dropdown=true&name=asc&token=",
};
// Customizable Area End

export interface Props {
  // Customizable Area Start
  navigation: {
    navigate: Function;
    getParam: Function;
  };
  id: string;
  // Customizable Area End
}

export interface S {
  // Customizable Area Start
  filters: IFilterItem[];
  sortingData: ISortingData;
  filterAnchor: { currentTarget: {} } | undefined | HTMLDivElement;
  totalCount: number;
  popOverTop: number;
  popOverLeft: number;
  endDate: Date | null | string | undefined;
  startDate: Date | null | string | undefined;
  popOverOpened: boolean;
  confirmModalFlag: boolean;
  confirmModalType: boolean;
  goldenPointList: Array<IGoldenPointItem>;
  permissionStatus: PermissionStatus;
  isLoadingPermission: boolean;
  isAppliedFilter: boolean;
  isLoading: boolean;
  sectionSelected: Array<string>;
  sectionList: Array<ISection>;
  statusSuggestions: [
    { id: "active"; title: "Active" },
    { id: "inactive"; title: "Inactive" }
  ];

  // Customizable Area End
}

export interface SS {}

class GoldenPointListController extends BlockComponent<Props, S, SS> {
  // Customizable Area Start
  filterQuery: string = "";
  searchQuery: string = "";
  currentPage: number = 1;
  rowPerPage: number = 20;
  sortQuery: string = "";

  goldenpointListMessageId: string = "";
  sectionSuggestionId: string = "";
  goldenpointNameSuggestionId: string = "";
  sectionMessageId: string = "";
  confirmModalValue: string = "";
  // popOverItemStatus: string = "";
  popOverItemStatus: boolean = true;

  deactivateMessageId: string = "";
  popOverItemId: string | number = "";

  sortingProps = {
    width: "18%",
    onQueryChange: (query: string) => {
      this.sortQuery = query;
      this.getGoldenPointApi();
    },
    onChange: (d: ISortingData) => this.setState({ sortingData: d }),
  };
  // Customizable Area End

  constructor(props: Props) {
    super(props);
    // Customizable Area Start
    this.subScribedMessages = [
      getName(MessageEnum.RestAPIResponceMessage),
      getName(MessageEnum.RestAPIResponceSuccessMessage),
      getName(MessageEnum.NavigationPayLoadMessage),
      getName(MessageEnum.RestAPIResponceDataMessage),
      getName(MessageEnum.SessionSaveMessage),
      getName(MessageEnum.SessionResponseMessage),
      getName(MessageEnum.LayoutDataMessage),
      getName(MessageEnum.SearchTextMessage),
    ];

    this.receive = this.receive.bind(this);
    runEngine.attachBuildingBlock(this as IBlock, this.subScribedMessages);
    // Customizable Area End
  }

  async receive(from: string, message: Message) {
    // Customizable Area Start
    this.extractDataFromLayout(message);
    this.gatherSearchTextData(message);
    const requestId = message.getData(
      getName(MessageEnum.RestAPIResponceDataMessage)
    );

    const successResponse = message.getData(
      getName(MessageEnum.RestAPIResponceSuccessMessage)
    );

    if (successResponse) {
      if (requestId === this.sectionMessageId) {
        this.setState({
          sectionList:
            successResponse.data.map(
              (item: { attributes: {} }) => item.attributes
            ) || [],
        });

        const seactionResults = successResponse.data?.map(
          (item: { id: number; attributes: { section_name: string } }) => {
            return {
              value: String(item.id),
              label: item.attributes.section_name,
            };
          }
        );
        const existingFilter = this.state.filters.find(
          (item) => item.title === "Section"
        );
        if (!existingFilter) return;
        existingFilter.options = seactionResults;
        this.setState({ filters: [...this.state.filters] });
      } else if (requestId === this.goldenpointListMessageId) {
        this.handleGoldenListResponse(successResponse);
      } else if (requestId === this.deactivateMessageId) {
        this.handleDeactivateResponse(successResponse);
      } else if (requestId === this.sectionSuggestionId) {
        const list =
          successResponse?.sections?.data?.map((s: any) => ({
            label: s.attributes.section_name,
            value: s.id,
          })) || [];

        const updatedFilters = this.state.filters.map((item: IFilterItem) => {
          if (item.title === "Section") item.options = list;
          return item;
        });

        this.setState({ filters: updatedFilters });
      } else if (requestId === this.goldenpointNameSuggestionId) {
        const list =
          successResponse?.filter_names?.map((value: string) => ({
            label: value,
            value,
          })) || [];
        const updatedFilters = this.state.filters.map((item: IFilterItem) => {
          if (item.title === "Section") item.options = list;
          return item;
        });
        this.setState({ filters: updatedFilters });
      }
    }
    // Customizable Area End
  }

  // Customizable Area Start
  async componentDidMount() {
    this.setState({
      isLoadingPermission: true,
      permissionStatus: {
        mainPermission: false,
        createPermission: false,
        viewPermission: false,
        editPermission: false,
        deactivatePermission: false,
        activatePermission: false,
      },
    });

    // Mock permission check - replace with actual permission logic
    setTimeout(() => {
      this.setState({
        isLoadingPermission: false,
        permissionStatus: {
          mainPermission: true,
          createPermission: true,
          viewPermission: true,
          editPermission: true,
          deactivatePermission: true,
          activatePermission: true,
        },
      });
    }, 500);

    this.getGoldenPointApi();
  }

  getGoldenPointApi = () => {
    this.setState({ isLoading: true });

    let url = `${ApiUrls.goldenPointList}?page_no=${this.currentPage}&per_page=${this.rowPerPage}`;

    if (this.sortQuery) {
      url += `&${this.sortQuery}`;
    }
    if (this.filterQuery) {
      url += `&${this.filterQuery}`;
    }
    if (this.searchQuery) {
      url += `&search=${this.searchQuery}`;
    }

    const requestMessage = MakeApiMessage({
      url: url,
      method: "GET",
    });

    this.goldenpointListMessageId = requestMessage.messageId;
    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  getSectionList() {
    let requestMessage: Message = MakeApiMessage({
      url: ApiUrls.sectionList + localStorage.getItem(configJSON.Strings.token),
      method: "GET",
    });
    this.sectionMessageId = requestMessage.messageId;
    runEngine.sendMessage(requestMessage.id, requestMessage);
  }

  handleFilterChange(event: { currentTarget: {} } | undefined) {
    this.setState({
      filterAnchor: event?.currentTarget as HTMLDivElement | undefined,
    });
    if (this.state.sectionList.length === 0) {
      this.getSectionList();
    }
    this.setState((prevState) => ({
      filters: prevState.filters.map((item) =>
        item.title === "Status"
          ? {
              ...item,
              options: prevState.statusSuggestions.map((s) => ({
                label: s.title,
                value: s.id,
              })),
            }
          : item
      ),
    }));
  }

  handleGoldenListResponse = (responseJson: any) => {
    this.setState({ isLoading: false });


    // Handle different possible response structures
    let goldenPointData = [];
    let total = 0;

    if (responseJson) {
      // Update current page if provided in response
      if (responseJson.meta?.current_page) {
        this.currentPage = responseJson.meta.current_page;
      }
      // Based on your API response structure: {data: [...]}
      if (responseJson.data && Array.isArray(responseJson.data)) {
        console.log("Using responseJson.data structure");
        goldenPointData = responseJson.data;
        total =
          responseJson.meta?.total_count ||
          responseJson.meta?.total ||
          responseJson.data.length ||
          0;
      } else if (Array.isArray(responseJson)) {
        console.log("Using direct array structure");
        goldenPointData = responseJson;
        total = responseJson.length;
      } else {
        console.log("Unexpected response structure:", responseJson);
        console.log(
          "Response keys:",
          responseJson ? Object.keys(responseJson) : "null"
        );

        // Try to extract data anyway if it exists
        const possibleData =
          responseJson?.data ||
          responseJson?.promotions ||
          responseJson; /* Should Change */
        if (Array.isArray(possibleData)) {
          goldenPointData = possibleData;
          total = possibleData.length;
        }
      }
    }

    this.setState({
      goldenPointList: goldenPointData,
      totalCount: total,
    });
  };

  onChangePage = (page: number) => {
    this.currentPage = page;
    this.getGoldenPointApi();
  };

  handleRedirection = (screenName: string) => {
    this.props.navigation.navigate(screenName);
  };

  onApplyFilter = (filters: IFilter[]) => {
    let query = "";
    let hasAppliedFilter = false;

    filters.forEach((filter) => {
      const { title, value, apiKey } = filter;
      if (
        value === undefined ||
        value === null ||
        value === "" ||
        (Array.isArray(value) && value.length === 0)
      ) {
        return;
      }

      hasAppliedFilter = true;

      if (title === "Date" && Array.isArray(value)) {
        const [startDate, endDate] = value;

        if (startDate && endDate) {
          query += `&filter_by[start_date]=${moment(startDate).format(
            "YYYY-MM-DD"
          )}`;
          query += `&filter_by[end_date]=${moment(endDate).format(
            "YYYY-MM-DD"
          )}`;
        }
        return;
      }
      if (title === "Section") {
        if (Array.isArray(value)) {
          value.forEach((v) => {
            query += `&filter_by[section_ids][]=${v}`;
          });
        } else {
          query += `&filter_by[section_ids][]=${value}`;
        }
        return;
      }
      if (title === "Status") {
        const mapStatus = (v: string) => (v === "active" ? true : false);
        if (Array.isArray(value)) {
          value.forEach((v) => {
            query += `&filter_by[status][]=${mapStatus(v)}`;
          });
        } else {
          query += `&filter_by[status]=${mapStatus(value as string)}`;
        }
        return;
      }

      if (apiKey) {
        if (Array.isArray(value)) {
          query += `&filter_by[${apiKey}]=${value.join(",")}`;
        } else {
          query += `&filter_by[${apiKey}]=${value}`;
        }
      }
    });

    this.filterQuery = query;
    this.currentPage = 1;
    this.setState({ isAppliedFilter: hasAppliedFilter });
    this.getGoldenPointApi();
  };

  handleReturnColorType = () => {
    return this.state.isAppliedFilter ? "primary" : "inherit";
  };

  onEditApi = (activate: boolean = false) => {
    const body = {
      data: {
        // status: activate ? "active" : "inactive"
        status: activate ? true : false,
      },
    };

    const requestMessage = MakeApiMessage({
      url: `${ApiUrls.goldenPointDeactivate}/${this.popOverItemId}`,
      method: "PUT",
      body: JSON.stringify(body),
    });

    this.deactivateMessageId = requestMessage.messageId;
    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  handleDeactivateResponse = (responseJson: any) => {
    this.setState({
      popOverOpened: false,
      confirmModalFlag: false,
      confirmModalType: true,
    });
    this.getGoldenPointApi();
  };

  handleConfirmModal = () => {
    if (!this.state.confirmModalType) {
      this.onEditApi();
    } else {
      this.setState({
        confirmModalFlag: false,
        confirmModalType: false,
      });
    }
  };

  getSectionSuggestionList(query: string) {
    let updated = this.state.filters.map((item: IFilterItem) => {
      if (item.title === "Section") item.value = query;
      return item;
    });

    this.setState({ filters: updated });

    let requestMessage = MakeApiMessage({
      url: ApiUrls.sectionSuggestion + query,
      method: "GET",
    });
    this.sectionSuggestionId = requestMessage.messageId;
    runEngine.sendMessage(requestMessage.id, requestMessage);
  }

  getGoldenPointSuggestionList(query: string) {
    let updated = this.state.filters.map((item: IFilterItem) => {
      if (item.title === "Golden Point Name") item.value = query;
      return item;
    });

    this.setState({ filters: updated });

    let requestMessage = MakeApiMessage({
      url: ApiUrls.goldenpointNameSuggestion + query,
      method: "GET",
    });
    this.goldenpointNameSuggestionId = requestMessage.messageId;
    runEngine.sendMessage(requestMessage.id, requestMessage);
  }

  extractDataFromLayout = (message: Message) => {
    const layoutDataMessage = message.getData(
      getName(MessageEnum.LayoutDataMessage)
    );

    if (layoutDataMessage) {
      const userContext = layoutDataMessage as IUserContext;
      if (userContext) {
        // Handle layout data if needed
      }
    }
  };

  gatherSearchTextData = (message: Message) => {
    const searchTextMessage = message.getData(
      getName(MessageEnum.SearchTextMessage)
    );

    if (searchTextMessage) {
      this.searchQuery = searchTextMessage;
      this.currentPage = 1;
      this.getGoldenPointApi();
    }
  };
  // Customizable Area End
}

export default GoldenPointListController;
